import { useEffect } from "react";
import { useAlert } from "react-alert";

const NotificationsComponent = ({ notifications }) => {
  const alert = useAlert();

  useEffect(() => {
    if (notifications.message) {
      alert.show(notifications.message.Text, {
        type: notifications.message.Type,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifications.message]);

  return null;
};

export default NotificationsComponent;
